module.exports = __webpack_public_path__ + "img/hive.296e0c19.svg";